import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function FAQ() {
  const faqSections = [
    {
      category: "Compte",
      questions: [
        {
          question: "Comment modifier mon identifiant et/ou mot de passe ?",
          answer: "Pour modifier votre identifiant et/ou mot de passe, cliquez sur votre prénom et photo situés en haut à droite de la page d'accueil.\n\nUn menu déroulant s'affiche vous permettant d'accéder à la rubrique \"Mon compte\" en cliquant. Sur cette page, changez votre identifiant et/ou mot de passe puis enregistrez vos modifications.\n\nPour valider ce changement, pensez à bien cliquer sur le lien qui vous est envoyé par email."
        },
        {
          question: "J'ai oublié mon mot de passe.",
          answer: "Pour signaler cet oubli, cliquez sur \"se connecter\" depuis la page d'accueil, puis \"mot de passe oublié\".\n\nInscrivez votre adresse mail afin d'obtenir un email de récupération qui vous permettra de réinitialiser votre mot de passe."
        },
        {
          question: "Comment modifier mon adresse de livraison ?",
          answer: "Pour modifier votre adresse de livraison préférée, cliquez sur votre prénom et photo situés en haut à droite de la page d'accueil.\n\nUn menu déroulant s'affiche vous permettant d'accéder à la rubrique \"Mon compte\" en cliquant.\n\nSur cette page, changez votre adresse de livraison préférée puis enregistrez vos modifications."
        },
        {
          question: "Comment se déconnecter ?",
          answer: "Pour vous déconnecter, cliquez sur votre prénom et photo situés en haut à droite de la page d'accueil. Un menu déroulant s'affiche vous permettant d'accéder au bouton \"Déconnexion\"."
        }
      ]
    },
    {
      category: "Commandes et livraisons",
      questions: [
        {
          question: "Comment bénéficier de la réduction sur ma commande ?",
          answer: "Vous pouvez en bénéficier si vous imprimez votre livre dans les 30 jours après sa création.\n\nRégulièrement, vous pouvez bénéficiez de remises ponctuelles à des moments forts de l'année !"
        },
        {
          question: "Comment suivre la livraison de ma commande ?",
          answer: "Pour suivre la livraison de votre album, cliquez sur votre prénom et photo situés en haut à droite de la page d'accueil.\n\nUn menu déroulant s'affiche vous permettant d'accéder à la rubrique \"Mon compte\" en cliquant. Sur cette page, défilez vers le bas pour trouver la section \"Mes commandes en cours\".\n\nIci, vous pourrez suivre le statut de votre livraison.\n\nPour plus de précision, référez vous au numéro de suivi indiqué en haut à gauche de votre commande en cours, cliquable pour accéder aux détails sur le site partenaire."
        },
        {
          question: "Comment signaler un problème de livraison ou de production ?",
          answer: "Pour signaler un problème de livraison ou de production, rendez-vous en bas de n'importe quelle page du site.\n\nCliquez sur \"Nous contacter\" pour voir apparaître un formulaire de contact.\n\nMentionnez bien en objet de votre demande \"Problème de livraison ou production\"."
        },
        {
          question: "Quels sont les frais de livraison ?",
          answer: "Les frais de livraison varient selon les modes de livraison. Vous pouvez être livré en point relais ou à domicile."
        }
      ]
    }
  ];

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-background to-soft">
      <Navigation />
      
      <main className="flex-1">
        {/* Hero Section */}
        <section className="py-12 lg:py-16 bg-gradient-primary mt-10">
          <div className="container mx-auto px-4 lg:px-8">
            <div className="max-w-3xl mx-auto text-center">
              <h1 className="font-display text-4xl lg:text-5xl font-bold text-gradient mb-4">
                Questions Fréquentes
              </h1>
              <p className="text-lg text-foreground">
                Trouvez rapidement les réponses à vos questions
              </p>
            </div>
          </div>
        </section>

        {/* FAQ Content */}
        <section className="">
          <div className="container mx-auto px-4 lg:px-8">
            <div className="max-w-4xl mx-auto space-y-12">
              {faqSections.map((section, sectionIndex) => (
                <div key={sectionIndex} className="space-y-6">
                  <h2 className="font-display text-2xl lg:text-3xl font-bold text-foreground">
                    {section.category}
                  </h2>
                  
                  <Accordion type="single" collapsible className="space-y-4">
                    {section.questions.map((item, questionIndex) => (
                      <AccordionItem
                        key={questionIndex}
                        value={`${sectionIndex}-${questionIndex}`}
                        className="bg-card rounded-xl shadow-card border-none overflow-hidden"
                      >
                        <AccordionTrigger className="px-6 py-5 text-left hover:no-underline hover:bg-accent/50 transition-smooth">
                          <span className="font-medium text-foreground pr-4">
                            {item.question}
                          </span>
                        </AccordionTrigger>
                        <AccordionContent className="px-6 pb-5">
                          <div className="text-muted-foreground leading-relaxed whitespace-pre-line">
                            {item.answer}
                          </div>
                        </AccordionContent>
                      </AccordionItem>
                    ))}
                  </Accordion>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
